var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { StudyStatus } from "healthex-common/study.dtos";
import { computed, observable } from "mobx";
export class StudyUsersDialogModel {
    constructor(opts) {
        this.update = null;
        this.studyManager = opts.container.studyManager;
        this.authManager = opts.container.authManager;
        this.organizationsManager = opts.container.organizationsManager;
        this.study = opts.study;
        this.onClose = opts.onClose;
        this.onBeforeUpdate = opts.onBeforeUpdate;
        this.onAfterUpdate = opts.onAfterUpdate;
    }
    updateOpts(opts) {
        this.study = opts.study;
        this.onClose = opts.onClose;
    }
    get existingUsers() {
        return this.study.users;
    }
    get readonly() {
        return [StudyStatus.COMPLETED, StudyStatus.WITHDRAWN].includes(this.study.status);
    }
    get orgName() {
        return this.authManager.orgName;
    }
    get title() {
        if (this.readonly) {
            return `View researchers who had access to ‘${this.study.title}’`;
        }
        else {
            return `Add team members to ‘${this.study.title}’`;
        }
    }
    onUpdate(update) {
        this.update = update;
    }
    async done() {
        if (this.onBeforeUpdate)
            await this.onBeforeUpdate();
        if (this.update) {
            await Promise.all([
                ...this.update.updated.map(async (updated) => {
                    await this.studyManager.createOrUpdateStudyUser(this.study.id, updated.user, {});
                }),
                ...this.update.removed.map(async (removed) => {
                    await this.studyManager.removeStudyUser(this.study.id, removed.user);
                }),
            ]);
            this.update = null;
        }
        if (this.onAfterUpdate)
            await this.onAfterUpdate();
        this.onClose();
    }
}
__decorate([
    observable
], StudyUsersDialogModel.prototype, "study", void 0);
__decorate([
    observable
], StudyUsersDialogModel.prototype, "onClose", void 0);
__decorate([
    observable
], StudyUsersDialogModel.prototype, "onBeforeUpdate", void 0);
__decorate([
    observable
], StudyUsersDialogModel.prototype, "onAfterUpdate", void 0);
__decorate([
    observable
], StudyUsersDialogModel.prototype, "update", void 0);
__decorate([
    computed
], StudyUsersDialogModel.prototype, "existingUsers", null);
__decorate([
    computed
], StudyUsersDialogModel.prototype, "readonly", null);
__decorate([
    computed
], StudyUsersDialogModel.prototype, "orgName", null);
__decorate([
    computed
], StudyUsersDialogModel.prototype, "title", null);
